// No model imports needed for the simplified header

interface WeatherSummaryHeaderProps {
  cityName: string;
  currentDate: string;
  endHour: number;
}

export function WeatherSummaryHeader({
  cityName,
  currentDate,
  endHour,
}: WeatherSummaryHeaderProps) {
  return (
    <div className="flex-shrink-0 px-3 sm:px-4 py-2 sm:py-3 bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 relative z-30">
      <div className="flex items-center justify-between gap-3">
        <div className="min-w-0 flex-1">
          <h2 className="text-base sm:text-lg font-bold text-gray-900 dark:text-gray-100 truncate">
            {cityName}
          </h2>
          <p className="text-xs text-gray-500 dark:text-gray-400">
            {currentDate} • {endHour}h forecast
          </p>
        </div>

        {/* Model badges intentionally hidden in weather summary */}
      </div>
    </div>
  );
}
